export default __webpack_public_path__ + "alberta-fab-next-visit.2c7bbec9a329ac233871.svg";